import { State } from '@app/state/types'
import { useSelector } from 'react-redux'

export default () => {
  return useSelector((state: State): any => state.adjustments.modifications)
}
